import { Card, Divider, Stack } from "@mui/material";
import { Fragment } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import { getFacilityBookings } from "@/services/booking";
import { EmptyResultIcon } from "@/components/EmptyResultIcon";
import { Pagination } from "@/components/Pagination";
import { CircularLoading } from "@/components/CircularLoading";

import { FacilityBookingCard } from "./FacilityBookingCard";
import { CancelFacilityBookingDialog } from "./CancelFacilityBookingDialog";
import { UploadBokingDialog } from "./UploadBookingDialog";

const QUERY_KEY = "getFacilityBooking";

export function FacilityBookingListPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = parseInt(searchParams.get("page") ?? "1") || 1;
  const { data: raw, isFetching } = useQuery([QUERY_KEY, page], () =>
    getFacilityBookings(`page=${page}`)
  );

  const dialog = searchParams.get("dialog") ?? "";
  const id = searchParams.get("id") ?? "";

  const bookings = raw?.data ?? [];

  const data = bookings.find((booking) => booking.id === +id);

  const onClose = () => {
    searchParams.delete("branchId");
    searchParams.delete("dialog");
    searchParams.delete("id");
    setSearchParams(searchParams, { replace: true });
  };

  const cancelBookingDialog = {
    open: dialog === "cancel-booking",
    data,
    onClose,
    fetchKeys: [QUERY_KEY],
  };

  const uploadBookingDialog = {
    open: dialog === "upload-booking",
    data,
    onClose,
    fetchKeys: [QUERY_KEY],
  };

  return (
    <Stack gap={5} alignItems="center">
      <Card
        sx={{
          maxWidth: "980px",
          width: "100%",
          textAlign: "-webkit-center",
        }}
      >
        {!isFetching ? (
          <>
            {bookings.length === 0 && (
              <Stack width="100vw" maxWidth={980} mx={{ xs: -4, md: -6 }}>
                <EmptyResultIcon variant="list" />
              </Stack>
            )}
            {bookings.map((item) => (
              <Fragment key={item.id}>
                <FacilityBookingCard data={item} />
                <Divider sx={{ width: "90%" }} />
              </Fragment>
            ))}
            <CancelFacilityBookingDialog {...cancelBookingDialog} />
            <UploadBokingDialog {...uploadBookingDialog} />
          </>
        ) : (
          <CircularLoading
            width="100vw"
            maxWidth={980}
            height={200}
            mx={{ xs: -4, md: -6 }}
          />
        )}
      </Card>
      <Pagination total={raw?.total} />
    </Stack>
  );
}
